import { collection, doc, setDoc, updateDoc, addDoc } from "firebase/firestore";
import { getProblemAttemptsCollectionPath, getTelemetryEventsCollectionPath } from "./firestorePaths";
import { ATTEMPT_FSM_VERSION } from "../fsm/problemAttemptFsm";

export const TELEMETRY_SCHEMA_VERSION = 1;

export const isTelemetryEnabled = () => {
  const explicit = process.env.REACT_APP_TELEMETRY_ENABLED;
  if (explicit === "true") return true;
  if (explicit === "false") return false;
  return process.env.NODE_ENV !== "production";
};

export const createProblemAttempt = async ({
  db,
  userId,
  listId,
  taskId,
  problemId = null,
  source = "unknown",
  state = "intake",
  nowMs = Date.now(),
  fsmVersion = ATTEMPT_FSM_VERSION,
  extra = {},
}) => {
  if (!db) throw new Error("db is required");
  if (!userId) throw new Error("userId is required");
  if (!listId) throw new Error("listId is required");
  if (!taskId) throw new Error("taskId is required");

  const attemptsRef = collection(db, getProblemAttemptsCollectionPath(userId, listId));
  const attemptRef = doc(attemptsRef);

  const payload = {
    taskId,
    problemId,
    source,
    fsmVersion,
    state,
    createdAt: nowMs,
    updatedAt: nowMs,
    ...extra,
  };

  await setDoc(attemptRef, payload);
  return { attemptId: attemptRef.id, attempt: payload };
};

export const updateProblemAttempt = async ({
  db,
  userId,
  listId,
  attemptId,
  updates = {},
}) => {
  if (!db) throw new Error("db is required");
  if (!userId) throw new Error("userId is required");
  if (!listId) throw new Error("listId is required");
  if (!attemptId) throw new Error("attemptId is required");

  const attemptsRef = collection(db, getProblemAttemptsCollectionPath(userId, listId));
  const attemptRef = doc(attemptsRef, attemptId);
  await updateDoc(attemptRef, updates);
};

export const appendTelemetryEvent = async ({
  db,
  userId,
  listId,
  event,
  nowMs = Date.now(),
}) => {
  if (!db) throw new Error("db is required");
  if (!userId) throw new Error("userId is required");
  if (!listId) throw new Error("listId is required");
  if (!event) throw new Error("event is required");

  if (!isTelemetryEnabled()) return null;

  const eventsRef = collection(db, getTelemetryEventsCollectionPath(userId, listId));
  const timestamp = Number.isFinite(event.timestamp) ? event.timestamp : nowMs;
  const payload = {
    schemaVersion: TELEMETRY_SCHEMA_VERSION,
    ...event,
    timestamp,
  };
  const ref = await addDoc(eventsRef, payload);
  return ref.id;
};
